// Bootstrap JS handles .active toggling via data-bs-toggle="button"
// No custom JS needed — Bootstrap handles everything if loaded by the theme.
